/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { openDB } from "idb";

import Context from "../context/context";
import QuantityEditable from "./QuantityEditable";
import PaymentPopup from "./PaymentPopup";
import { ShoppingBagIcon, PencilAltIcon } from "@heroicons/react/solid";

export const BillingSidebar = () => {

    const [isPaymentOptionOpen, setPaymentOptionOpen] = useState({ status: null, amount: 0 });
    const context = useContext(Context);
    const [domState, setDomState] = useState("");
    const [seatLocation, setSeatLocation] = useState(null);
    const [currentOrder, setCurrentOrder] = useState(null);
    const [totalAmount, setTotalAmount] = useState(0);
    const [page2Total, setPage2Total] = useState(0);

    const path = window.location.pathname;
    const params = path.split('/').filter(i => i !== "");
    const order_uuid_param = params[2]?.split('?')[0];
    console.log({ order_uuid_param })
    const [itemCharges, setItemCharges] = useState({ data: [] })
    const [printField, setPrintField] = useState(null);

    const {
        itemChargesHandlerRef, itemChargesValueRef,
        cartHandler,
        new_kotOrder,
        updateUnSync
    } = context;

    const [customerInfo, setCustomerInfo] = useState({ name: '', number: '' })
    // get order & all-items list from idb
    useEffect(() => {
        let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        DBOpenReq.onerror = err => console.warn(err);
        DBOpenReq.onsuccess = ev => {
            let db = ev.target.result;
            let store = db.transaction("Orders", "readonly").objectStore("Orders");
            let getOrder = store.get(order_uuid_param);
            getOrder.onsuccess = (orderEvent) => {
                const order = orderEvent.target.result;
                if (!order) return;
                setCurrentOrder(order);

                let tx = db.transaction("outlet", "readonly").objectStore("outlet");
                let outletReq = tx.get(localStorage.getItem('outlet_uuid'))
                outletReq.onsuccess = e => {
                    const outlet = e.target.result;
                    let invoice_setup = outlet.invoice_setup?.find(i => i.brand_uuid === order?.brand_uuid)
                    console.log("----> THIS IS BRAND_UUID: ", order?.brand_uuid, invoice_setup)
                    setPrintField(invoice_setup);
                }
            }
        }
    }, [])

    function seatLocationHandler() {
        let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        DBOpenReq.onerror = err => console.warn(err);
        DBOpenReq.onsuccess = ev => {
            let db = ev.target.result;
            let tx = db.transaction("seats", "readonly");
            let store = tx.objectStore("seats");

            let getSeatReq = store.get(currentOrder.seat_uuid);
            getSeatReq.onsuccess = (seat) => {
                tx = db.transaction("outlet", "readonly");
                store = tx.objectStore("outlet");

                let getOutlet = store.getAll();
                getOutlet.onsuccess = (outlet) => {
                    const selectedSeatSection =
                        outlet.target.result[0].section_details.find(
                            (section) =>
                                section.section_uuid === seat.target.result.section_uuid
                        );

                    setSeatLocation({
                        section: selectedSeatSection.section_name,
                        seat: seat.target.result.seat_name,
                    });
                };
            };
        }
    }

    function restorePreviouslyPendingOrders() {
        if (+currentOrder.order_status === 4) return;
        else
            if (+currentOrder.order_type === 0) {
                const unplaced_orders = JSON.parse(localStorage.getItem("unplaced_orders"));
                if (unplaced_orders) {
                    const unplaced_seat_order = unplaced_orders.find(
                        (json) => json.seat === currentOrder.seat_uuid
                    );
                    unplaced_seat_order && setItemCharges({ data: unplaced_seat_order.items });
                }
            } else {
                let unplacedNonseatOrders = JSON.parse(localStorage.getItem("unplaced-nonseat-order")) || [];
                let currentOrder = unplacedNonseatOrders.find((i) => i.order_uuid === currentOrder.order_uuid);

                if (currentOrder) setItemCharges({ data: currentOrder.items });
            }
    }

    // update order related default details
    useEffect(() => {
        if (!currentOrder) return;

        if (+currentOrder.order_type === 0)
            seatLocationHandler();

        setPage2Total(+currentOrder.order_total);
        restorePreviouslyPendingOrders();
    }, [currentOrder])

    // Set amount for order
    useEffect(() => {
        if (sessionStorage.getItem('is-payment-popup') === "true") return;
        let amount = itemCharges.data?.reduce((sum, element) => sum + +element.order_item_amount_inclusive_taxes, 0);
        amount = amount.toFixed(+sessionStorage.getItem("decimal_length") || 2);
        setTotalAmount(+amount);
        if (currentOrder) setPage2Total(+currentOrder.order_total + +amount);
    }, [itemCharges]);

    // Show available contact suggestions from customer json.
    function showSuggestions(e) {
        const input = e.target.value.toLowerCase();
        const container = document.getElementById("suggestions-div");
        const detailsArray = JSON.parse(sessionStorage.getItem("customer_details")) || [];

        if (input.length > 2 && detailsArray) {
            const inputType = e.target.type;
            if (inputType === "text") container.style.justifyContent = "flex-end";
            else container.style.justifyContent = "flex-start";
            container.style.display = "flex";

            let labelsHTML = (
                <div>
                    {detailsArray.map((customer) => {
                        if (
                            customer.customer_mobile &&
                            customer.customer_name
                        )
                            if (
                                customer.customer_mobile.includes(input) ||
                                customer.customer_name.includes(input)
                            )
                                if (inputType === "number")
                                    return (
                                        <label
                                            key={Math.random()}
                                            className="contact-suggestion"
                                            onClick={(e) => details_fill_handler(e)}
                                        >
                                            <div className="bold" name="customer_mobile">
                                                {customer.customer_mobile}
                                            </div>
                                            <div className="light" name="customer_name">
                                                {customer.customer_name}
                                            </div>
                                        </label>
                                    );
                                else if (inputType === "text")
                                    return (
                                        <label
                                            key={Math.random()}
                                            className="contact-suggestion"
                                            onClick={(e) => details_fill_handler(e)}
                                        >
                                            <div className="bold" name="customer_name">
                                                {customer.customer_name}
                                            </div>
                                            <div className="light" name="customer_mobile">
                                                {customer.customer_mobile}
                                            </div>
                                        </label>
                                    );
                                else return ''
                            else return ''
                        else return ''
                    })}
                </div>
            );
            setDomState(labelsHTML);
        } else container.style.display = "none";
    }

    // Fill selected contact details automatically in target input fields
    function details_fill_handler(e) {
        const name = e.target.parentNode.querySelector(
            '[name="customer_name"]'
        ).innerText;
        const number = e.target.parentNode.querySelector(
            '[name="customer_mobile"]'
        ).innerText;

        setCustomerInfo({ name: name, number: number.slice(number.length - 10) });
        sessionStorage.setItem('customer-updated-info', JSON.stringify({ name: name, number: number.slice(number.length - 10) }))
    }

    // Update user contact details into the indexeddb. (CALLED WHEN a user leave input field -> onBlur())
    const updateContact = () => {
        let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        DBOpenReq.onerror = err => console.warn(err);
        DBOpenReq.onsuccess = ev => {
            let db = ev.target.result;

            let store = db.transaction("Orders", "readonly").objectStore("Orders");
            let getOrder = store.get(order_uuid_param);
            getOrder.onsuccess = (orderEvent) => {
                const order = orderEvent.target.result;
                const info = JSON.parse(sessionStorage.getItem('customer-updated-info'));
                console.log(info);
                // console.log("found seat order", order);
                order.customer_mobile = info.number;
                order.customer_name = info.name;
                store.put(order);
            };
            setTimeout(() => {
                document.getElementById("suggestions-div").style.display = "none";
            }, 300);
        };
    };

    // save instruction into item state
    function saveInstruction(item, inst_field_id) {
        const instruction = document.getElementById(`${inst_field_id}`).getElementsByTagName("textarea")[0].value;
        instruction && cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action: "instruction", instruction });
        setTimeout(() => { toggleInstructionField(inst_field_id, "remove") }, 300);
    }

    // toggle instruction fileld box
    function toggleInstructionField(inst_field_id, action) {
        action === "toggle" &&
            document.getElementById(`${inst_field_id}`).classList.toggle("active");
        action === "remove" &&
            document.getElementById(`${inst_field_id}`).classList.remove("active");
        document
            .getElementById(`${inst_field_id}`)
            .getElementsByTagName("textarea")[0]
            .focus();
    }

    // manage instruction field rows and update length limit
    function instructionChange(e) {
        const rows = e.target.value.match(/\n/g);
        if (rows && rows < 3) e.target.rows = 3;
        else if (rows) e.target.rows = rows.length + 1;
        e.target.nextSibling.innerText = `${e.target.value.length}/200`;
    }

    // clear instruction from items state
    const clearInstruction = (item) => cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action: "parcel", instruction: "remove-cooking-instruction" });

    // Update parcel selection and calculation
    const addParcel = item => cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action: "parcel" });

    // handle putting updated order copy into idb unsynced files
    const handleMenuAddUnsyncedFiles = async (data) => {
        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
        const ndata = {
            invoice_series: data,
            RECON_TIME: new Date().getTime().toString(),
            IDENTIFIER: "invoice_series:" + data.series,
        };
        await tx.put(ndata);
        handleMenuReconciliation(ndata);
        updateUnSync()
    };

    // Adding/Editing menu to reconciliation collection in IndexedDB
    const handleMenuReconciliation = async (data) => {
        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = await db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
        const allReconRecords = await tx.getAll();

        const menusJsonExists = allReconRecords.find((curr) => curr.IDENTIFIER === "invoice_series");
        if (menusJsonExists) {
            const menus = menusJsonExists?.details?.filter((menu) => menu.user_uuid !== data.user_uuid)
            const editData = {
                ...menusJsonExists,
                details: [
                    ...menus,
                    {
                        user_uuid: data.user_uuid,
                        RECON_TIME: data.RECON_TIME,
                    },
                ],
            };
            await tx.put(editData)

        } else {
            const newdata = {
                IDENTIFIER: "invoice_series",
                details: [
                    {
                        user_uuid: data.user_uuid,
                        RECON_TIME: data.RECON_TIME,
                    },
                ]
            };
            await tx.add(newdata);
        }
    }

    // Handle a new order creation or old order updation
    function createJson(json, outlet) {
        console.log("function called");
        if (!itemCharges || itemCharges.data?.length === 0) return;
        console.log("worked till here", json, outlet);
        // console.log("Found a running order for this seat in IDB");
        // console.log("updating order...");
        let time = Date.now();

        json = new_kotOrder({ json, outlet, time, buttonStatus: 1, cartItems: itemCharges.data });
        json.order_total = json.order_total.toFixed(Number(sessionStorage.getItem("decimal_length")));
        console.log(json.order_total);
        json.modified_at = time;
        outlet.invoice_series.forEach((s) => {
            if (json.local_order_id.includes(s.series)) {
                s.last_used_at = Date.now();
                if (+s.next_kot_number < +s.kot_end)
                    s.next_kot_number = +s.next_kot_number + 1;
                else s.next_kot_number = +s.kot_start;
            }
        });

        handleMenuAddUnsyncedFiles(outlet.invoice_series.find(a => a.user_uuid === localStorage.getItem("user_uuid")))
        setItemCharges({ data: [] });

        if (json.seat_uuid && +json.order_status !== 4) {
            let unplacedOrders = JSON.parse(localStorage.getItem("unplaced_orders")) || [];
            unplacedOrders = unplacedOrders.filter(i => i.seat !== json.seat_uuid);
            localStorage.setItem("unplaced_orders", JSON.stringify(unplacedOrders));
        }
        console.log({ json, outlet });
        return { json, outlet }
    };

    // show warning to add customer mobile
    function noCustomerWarning() {
        clearInterval(sessionStorage.getItem("notification-warning-timeout"));
        document.querySelector(".notification-message").innerText = "Mobile Number required for eBill";
        document.querySelector(".notification-container").classList.add("active-red");

        const timeoutId = setTimeout(() => {
            document
                .querySelector(".notification-container")
                .classList.remove("active-red");
        }, 2000);

        sessionStorage.setItem("notification-warning-timeout", timeoutId);
    }

    // Handle invoice printing, store seat list locally and update invoice json in target order-store in indexeddb
    const printInvoice = async (num, ebill = false, debug_print) => {

        if (ebill) {
            if (customerInfo.number === "") { noCustomerWarning(); return false };
        }

        let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        DBOpenReq.onerror = err => console.warn(err);
        DBOpenReq.onsuccess = ev => {

            let tx = ev.target.result.transaction("Orders", "readwrite");
            let store = tx.objectStore("Orders");

            let getOrders = store.get(order_uuid_param);

            getOrders.onsuccess = (orderReq) => {
                let order = orderReq.target.result;
                let object = {
                    at: Date.now(),
                    copies: orderReq.target.innerText,
                    user_uuid: localStorage.getItem("user_uuid"),
                };
                order.invoice_prints = order.invoice_prints || [];
                order.invoice_prints.push(object);
                store.put(order);
            };
        };
        return true;
    };

    function setItemChargesFunction() {
        console.log(itemChargesValueRef.current);
        setItemCharges({ data: itemChargesValueRef.current })
    }

    useEffect(() => {
        console.log(itemCharges);
    }, [itemCharges])

    return (
        <>
            <div
                ref={itemChargesHandlerRef}
                onClick={setItemChargesFunction}
                style={{ display: "none" }}
            />
            <div
                className={`info ${document.querySelector(".brands-tabs") ? "touchTop" : ""}`}
            >
                <div className="info-container">
                    <div className="inputs">
                        <input
                            type="number"
                            id="contact-number"
                            value={customerInfo.number}
                            onChange={(e) => {
                                setCustomerInfo({ ...customerInfo, number: e.target.value });
                                showSuggestions(e);
                                sessionStorage.setItem('customer-updated-info', JSON.stringify({ ...customerInfo, number: e.target.value, seat: currentOrder.seat_uuid }))
                            }}
                            onBlur={() => setTimeout(() => updateContact(), 300)}
                            placeholder="Mobile no."
                        />
                        <input
                            type="text"
                            id="contact-name"
                            value={customerInfo.name}
                            onChange={(e) => {
                                setCustomerInfo({ ...customerInfo, name: e.target.value });
                                showSuggestions(e);
                                sessionStorage.setItem('customer-updated-info', JSON.stringify({ ...customerInfo, name: e.target.value, seat: currentOrder.seat_uuid }))
                            }}
                            onBlur={() => setTimeout(() => updateContact(), 300)}
                            placeholder="Customer Name"
                        />
                    </div>
                    <div id="suggestions-div" style={{ display: "none" }}>
                        {domState}
                    </div>
                    <div className="name">
                        {currentOrder && currentOrder.order_type === 0 && seatLocation && (
                            <h3>
                                {seatLocation.section || null} {seatLocation.seat || null} : Rs.
                                <span id="total-amount">{Math.round(totalAmount)}</span>
                            </h3>
                        )}
                    </div>
                    <div className="description-container">
                        <table className="description">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                    <th>Amount</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemCharges &&
                                    itemCharges.data?.map((element, index) => {
                                        const cookingInstructionID = `${element.item_uuid}${Math.random()}`;
                                        return (
                                            <tr key={Math.random()}>
                                                <td>{element.item_name}</td>
                                                <td><QuantityEditable quantity={element.order_item_qty} item={element} /></td>
                                                <td>Rs.{+element.order_item_taxable_value}</td>
                                                <td>
                                                    <div
                                                        style={{
                                                            display: "inline-block",
                                                            position: "relative",
                                                        }}
                                                        onBlur={() => saveInstruction(element, cookingInstructionID)}
                                                    >
                                                        <PencilAltIcon
                                                            style={{
                                                                height: "20px",
                                                                color: element.order_item_instruction ? "red" : "black",
                                                            }}
                                                            onClick={() => toggleInstructionField(cookingInstructionID, "toggle")}
                                                        />
                                                        <div
                                                            id={cookingInstructionID}
                                                            className={`item-edit-popup ${index <= 1 ? "bottom" : "top"}`}
                                                        >
                                                            <textarea
                                                                maxLength="200"
                                                                rows={3}
                                                                placeholder="Instructions.."
                                                                defaultValue={element.order_item_instruction || ""}
                                                                onChange={(e) => instructionChange(e)}
                                                            />
                                                            <span
                                                                id="instruction_length"
                                                                style={{
                                                                    color: "grey",
                                                                    padding: "2px 5px",
                                                                    fontSize: "13px",
                                                                }}
                                                            >
                                                                0/200
                                                            </span>
                                                            <div className="item-edit-popup-actions">
                                                                <button
                                                                    className="red"
                                                                    onClick={() => clearInstruction(element, cookingInstructionID)}
                                                                >
                                                                    Clear
                                                                </button>
                                                                <button
                                                                    style={{ backgroundColor: "#44cd4a" }}
                                                                    onClick={() => saveInstruction(element, cookingInstructionID)}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ShoppingBagIcon
                                                        onClick={() => addParcel(element)}
                                                        style={{
                                                            color: element.parcel === "Y" ? "#44cd4a" : element.parcel === "N" ? "black" : "#0080008a",
                                                            height: "20px",
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="info-actions">
                    <button
                        onClick={(e) => {
                            sessionStorage.setItem('is-payment-popup', true);
                            setPaymentOptionOpen({
                                status: true,
                                amount: page2Total
                            });
                        }}
                        id="payment-btn"
                        className="col-4"
                        style={{ backgroundColor: "#44cd4a" }}
                    >
                        Save & Payment Rs.{page2Total}
                    </button>
                </div>
            </div>
            {isPaymentOptionOpen.status && (
                <PaymentPopup
                    printField={printField}
                    customerInfo={customerInfo}
                    setCustomerInfo={setCustomerInfo}
                    isPaymentOptionOpen={{
                        ...isPaymentOptionOpen,
                        orderProps: {
                            order_type: currentOrder?.order_type,
                            order_status_param: 4,
                            order_uuids: [order_uuid_param],
                            order_uuid: order_uuid_param,
                            brand_orders: [{
                                order_uuid: currentOrder?.order_uuid,
                                brand_uuid: currentOrder?.brand_uuid
                            }]
                        }
                    }}
                    setPaymentOptionOpen={setPaymentOptionOpen}
                    printInvoice={printInvoice}
                    createJson={createJson}
                    new_kotOrder={new_kotOrder}
                />
            )}
        </>
    )
}